<template lang="pug">
    .properties
        el-form-item(:label="$t('Property Set')" prop="propSet.id")
            el-input.loading(v-if="form.propSet && options.propSet.loading" :value="form.propSet.name" :disabled="true")
            //- :disabled="options.propSet.items.length <= 1"
            el-select.is-full-width(
                v-else
                placeholder="" v-model="propSet" valueKey="id"
                :class="{ 'loading': options.propSet.loading }"
            )
                el-option(v-for="item in options.propSet.items" :key="item.id" :label="item.name" :value="item")

        transition(name="slide-decent-vertical")
            .alert.sticky.warning(v-if="articlesMustBeRegenerated")
                b {{ $t('Info') }}
                p {{ $t('The articles will be regenerated because the attributes have changed.') }}

        draggable.properties.no-style-list(
            v-if="propertyPivots.length"
            v-model="propertyPivots"
            tag="ul"
            group="properties"
            handle=".handle"
        )
            li.property(
                v-for="propertyPivot in propertyPivots"
                :key="propertyPivot.id"
                :class="{ deleted: propertyPivot.deleted }"
            )
                el-button.restore-button(
                    v-if="propertyPivot.deleted"
                    circle plain
                    type="success"
                    icon="el-icon-fa-trash-restore fas"
                    @click.stop.prevent="restorePropertyPivot(propertyPivot)"
                )
                el-tooltip(v-if="!propertyPivot.deleted && propertyPivot.property.article_required && form.id && propertyPivot.valueOptions.length > 1" :content="$t('Dissolve by attribute')" placement="top")
                    el-button.dissolve-button(
                        circle plain
                        type="warning"
                        icon="el-icon-fa-object-ungroup fas"
                        @click.stop.prevent="dissolveByProperty(propertyPivot)"
                    )
                el-button.delete-button(
                    v-if="!propertyPivot.deleted && !propertyPivot.property.default && !propSet.properties.find(el => el.id === propertyPivot.property.id)"
                    circle plain
                    type="danger"
                    icon="el-icon-fa-trash-alt fas"
                    @click="deletePropertyPivot(propertyPivot)"
                )
                .panel(
                    :class="{ clickable: !propertyPivot.deleted && propertyPivot.property.propType && propertyPivot.property.propType.key !== 'input' && propertyPivot.property.propType.key !== 'upload', 'no-body': propertyPivot.valueOptions && propertyPivot.valueOptions.length <= 0 }"
                    @click="openModal(propertyPivot)"
                )
                    .header.handle
                        label
                            span.info.stock
                                i.el-icon-fa-tasks.fas(v-if="propertyPivot.property.article_required")
                                i.el-icon-fa-tag.fas(v-else)
                            span {{ propertyPivot.property.name }}
                            code.pivot-key(v-if="propertyPivot.property.key") {{ propertyPivot.property.key }}
                            //- A dependent property only works when its trigger is on the product too.
                            template(v-if="propertyConditionsFeatureEnabled && propertyPivot.property.conditionProperty")
                                el-tooltip(
                                    v-if="!hasConditionTrigger(propertyPivot)"
                                    :content="$t('Depends on {property}, which is not attached to this product. It is shown without condition.', { property: propertyPivot.property.conditionProperty.name })"
                                    placement="top"
                                )
                                    el-tag.condition-tag(type="warning" size="mini")
                                        i.el-icon-warning
                                        | {{ $t('Depends on {property}', { property: propertyPivot.property.conditionProperty.name }) }}
                                span.info.condition(v-else) {{ $t('Depends on {property}', { property: propertyPivot.property.conditionProperty.name }) }}
                        //- .infos
                        //-     .info.type {{ $t(propertyPivot.property.propType.key) }}
                        //-     .info.stock(:class="{ active: propertyPivot.property.article_required }")
                        //-         i.el-icon-fa-tasks.fas
                    .body(v-if="propertyPivot.valueOptions.length")
                        ul
                            //- //- v-model="propertyPivot.valueOptions"
                            //- draggable(
                            //-     :value="propertyPivot.valueOptions"
                            //-     draggable="li"
                            //-     @sort="event => sortPropertyPivotValueOptions(event, propertyPivot)"
                            //- )
                            //- //- .filter(value => getLabel(value, propertyPivot.property))
                            //- li.handle(v-for="valueOption in propertyPivot.valueOptions")
                            li(v-for="valueOption in propertyPivot.valueOptions")
                                el-tag
                                    span.value {{ getLabel(valueOption, propertyPivot.property) || '‎' }}
                                        span.unit(v-if="propertyPivot.property.propType.key === 'unit' && propertyPivot.property.unit") {{ propertyPivot.property.unit }}
                                    el-tooltip(v-if="surchargeDiffers(valueOption)" placement="top")
                                        template(#content)
                                            .surcharge-groups
                                                div(v-for="line in surchargeLines(valueOption)" :key="line.id") {{ line.text }}
                                        span.surcharge.differs {{ surchargeOf(valueOption) }}
                                    span.surcharge(v-else-if="surchargeOf(valueOption)") {{ surchargeOf(valueOption) }}

        el-button(type="primary" icon="el-icon-fa-plus fas" @click="openModal") {{ $t('Add attribute') }}

        el-dialog.dissolve-product-dialog(
            :title="$t('Dissolve by attribute')"
            :visible.sync="dissolveModal.visibility"
            :close-on-click-modal="false"
            top="10vh"
            width="560px"
        )
            .modal-body(v-if="!dissolveModal.loading")
                .alert.warning
                    i.el-icon-warning
                    .text
                        p {{ $t('This will create a separate product for each value of this attribute. The original product will be disabled. This action cannot be undone.') }}
            .modal-body(v-else)
                div(v-loading="true" style="min-height: 80px;")
            template(slot="footer")
                el-button(size="mini" icon="el-icon-fa-times fas" :disabled="dissolveModal.loading" @click="closeDissolveModal") {{ $t('Cancel') }}
                el-button(size="mini" type="warning" icon="el-icon-fa-object-ungroup fas" :loading="dissolveModal.loading" @click="confirmDissolve") {{ $t('Dissolve') }}

        el-dialog(
            :title="modal.title"
            :visible.sync="modal.visibility"
            :close-on-click-modal="false"
            top="10vh"
            width="90%"
            @opened="focusModalSearch"
            @closed="resetModal"
        )
            transition(:name="modal.transition" mode="out-in")
                el-form.property-modal-form(
                    v-if="modal.type === 'edit' || (modal.pending === true && !modal.type === 'value-option-form')"
                    key="edit"
                    :model="modal.form"
                    label-position="top"
                    :rules="modalRules"
                    ref="modal"
                    v-loading="modal.loading"
                    @submit.prevent.native="submitModalForm"
                )
                    //- el-form-item(size="mini")
                    //-     el-switch(
                    //-         :active-text="$t('Can be configured by the customer.')"
                    //-         inactive-color="#ff4949"
                    //-         v-model="modal.form.is_configurable"
                    //-     )
                    //-     //- el-popover(
                    //-     //-     placement="right"
                    //-     //-     title="Title"
                    //-     //-     width="200"
                    //-     //-     trigger="hover"
                    //-     //-     content="this is content, this is content, this is content"
                    //-     //- )
                    //-     //-     el-button.info-tooltip(slot="reference" circle)
                    //-     //-         i.el-icon-fa-question-circle.fas
                    //- el-form-item(size="mini")
                    //-     el-switch(
                    //-         :active-text="$t('Leads to additional articles with inventory and extensive setting options.')"
                    //-         inactive-color="#ff4949"
                    //-         v-model="modal.form.article_required"
                    //-         disabled
                    //-     )
                    //-     //- el-popover(
                    //-     //-     placement="right"
                    //-     //-     title="Title"
                    //-     //-     width="200"
                    //-     //-     trigger="hover"
                    //-     //-     content="this is content, this is content, this is content"
                    //-     //- )
                    //-     //-     el-button.info-tooltip(slot="reference" circle)
                    //-     //-         i.el-icon-fa-question-circle.fas
                    //- What is already chosen stays in view: with thousands of rows the
                    //- selection is otherwise impossible to see or undo.
                    .picked-options(v-if="selectedValueOptions.length")
                        .picked-option(v-for="option in selectedValueOptions" :key="option.id")
                            span.dot(
                                v-if="option.color"
                                :style="{ background: option.color }"
                            )
                            span.label {{ option.value || option.text }}
                            i.el-icon-fa-times.fas(@click.prevent.stop="toggleOption(option)")

                    //- Picking variant options builds a variant matrix, and until now the
                    //- form only revealed how many articles that meant after saving.
                    .variant-consequence(v-if="variantConsequence")
                        span {{ variantConsequence.summary }}
                        span.new(v-if="variantConsequence.added") {{ $t('{count} new', { count: variantConsequence.added }) }}
                        el-tooltip(placement="top" :open-delay="150")
                            template(#content)
                                .variant-consequence-help
                                    p
                                        template(v-for="(part, index) in variantConsequence.parts")
                                            template(v-if="index") , 
                                            | {{ part.name }}: {{ part.current ? $t('{count} chosen', { count: part.count }) : $t('{count} values', { count: part.count }) }}
                                    p {{ $t('That makes {total} articles, one for each combination. Each one has its own article number, stock and price.', { total: variantConsequence.total }) }}
                                    p(v-if="variantConsequence.added") {{ $t('Saving adds {added} articles to the {existing} the product already has.', { added: variantConsequence.added, existing: variantConsequence.existing }) }}
                                    p(v-else-if="variantConsequence.existing") {{ $t('The product already has all of them.') }}
                            el-button.help-button(
                                circle plain size="mini"
                                icon="el-icon-fa-question fas"
                                :aria-label="$t('What does this mean?')"
                                @click.stop.prevent
                            )

                    //- The box has to survive its own results: searching a five-figure
                    //- property down to two hits must not take the search box away with it.
                    el-form-item(v-if="modal.options.length || modal.searchable || modal.filter")
                        el-input(
                            ref="optionSearch"
                            v-model="modal.filter"
                            v-focus
                            clearable
                            prefix-icon="el-icon-fa-search fas"
                            :placeholder="$t('Search options')"
                            @input="onOptionSearch"
                        )
                    transition(:name="modal.transition" mode="out-in")
                        //- el-form-item
                        //-     //- :icon="isActiveOption(pivot) ? 'el-icon-fa-check-square fas' : 'el-icon-fa-square far'"
                        //-     el-button.property-button(
                        //-         v-if="modal.options.length"
                        //-         v-for="item in filteredOptions" :key="item.value"
                        //-         plain
                        //-         :type="isActiveOption(item) ? 'primary' : 'info'"
                        //-         :class="{ highlight: item.highlight, match: item.match }"
                        //-         @click="toggleOption(item)"
                        //-     )
                        //-         template(v-if="modal.form.property.propType && modal.form.property.propType.key === 'color'")
                        //-             span.color(
                        //-                 v-if="item.color"
                        //-                 :style="'background: ' + getPropertyHexValue(item)"
                        //-             )
                        //-         span {{ (item.value || '‎') | cleanup }}
                        //-             span.unit(
                        //-                 v-if="modal.form.property.propType && modal.form.property.propType.key === 'unit' && modal.form.property.unit"
                        //-             ) {{ modal.form.property.unit }}
                        //-     el-date-picker(
                        //-         v-if="modal.form.property.propType && modal.form.property.propType.key === 'date'"
                        //-         :class="modal.options.length ? 'add-option' : 'is-full-width'"
                        //-         prefix-icon="far el-icon-fa-calendar-alt"
                        //-         :format="getDateformat(modal.form.property)"
                        //-         :type="modal.form.property.datetype"
                        //-         :picker-options="{firstDayOfWeek:1}"
                        //-         @input="addDateOption"
                        //-     )
                        //-     el-input(
                        //-         v-if="!(modal.form.property.propType && modal.form.property.propType.key === 'date')"
                        //-         v-model="modal.additionalOptionValue"
                        //-         :class="modal.options.length ? 'add-option' : 'is-full-width'"
                        //-         :type="modal.additionalOptionType"
                        //-         :placeholder="$t('Add option')"
                        //-         @keydown.escape.native="resetNewOption"
                        //-         @keydown.enter.native.prevent="event => addNewOption()"
                        //-     )
                        //-         i.unit(
                        //-             v-if="modal.form.property.propType && modal.form.property.propType.key === 'unit' && modal.form.property.unit"
                        //-             slot="suffix"
                        //-         ) {{ modal.form.property.unit }}
                        //-         el-button(
                        //-             slot="append"
                        //-             type="primary"
                        //-             icon="el-icon-fa-plus fas"
                        //-             @click="event => addNewOption()"
                        //-         )

                        //- The set is loaded a page at a time as it is scrolled, so a
                        //- property with thousands of options opens as fast as one with ten.
                        .value-options.table-content(
                            v-if="modal.form.property.propType && modal.form.property.propType.key !== 'input' && modal.form.property.propType.key !== 'upload'"
                            @scroll.passive="onOptionsScroll"
                        )
                            table.table(v-if="modal.options.length")
                                thead
                                    tr
                                        th.check
                                            el-checkbox(
                                                @change="toggleOption('all')"
                                            )
                                        th.hidden ID
                                        th.hidden
                                        th.image(align="center") {{ $t('Image') }}
                                        th.color(v-if="modal.form.property.propType.key === 'color'") {{ $t('Color') }}
                                        th {{ $t('Value') }}
                                        th.surcharge {{ $t('Surcharge') }}
                                        th {{ $t('Addition') }}
                                        th {{ $t('Description') }}
                                        th(v-if="valueOptionGroupsFeatureEnabled") {{ $t('Group') }}
                                        th.actions(v-if="!modal.form.property.article_required")
                                tbody
                                    tr.clickable(
                                        v-for="(item, i) in filteredOptions"
                                        :key="item.id"
                                        :class="{ highlight: item.highlight, match: item.match, active: isActiveOption(item) }"
                                    )
                                        td.checkbox.text-gray
                                            el-checkbox(
                                                :value="isActiveOption(item)"
                                                @change="toggleOption(item)"
                                            )
                                        td.id.hidden {{ item.id }}
                                        td.count.hidden {{ i+1 }}
                                        td.image.event-listener(
                                            align="center"
                                            @mouseover="hover"
                                            @mouseout="blur"
                                            @click.prevent.stop="toggleOption(item)"
                                        )
                                            template(v-if="item.translationOrigin")
                                                img(
                                                    v-if="item.translationOrigin.image && item.translationOrigin.image.source"
                                                    :width="item.translationOrigin.image.width"
                                                    :height="item.translationOrigin.image.height"
                                                    :src="item.translationOrigin.image.source.url"
                                                )
                                            template(v-else)
                                                img(
                                                    v-if="item.image && item.image.source && !item.image.deleted"
                                                    :width="item.image.width"
                                                    :height="item.image.height"
                                                    :src="item.image.source.url"
                                                )
                                        td.color.event-listener(
                                            v-if="modal.form.property.propType.key === 'color'"
                                            @mouseover="hover"
                                            @mouseout="blur"
                                            @click.prevent.stop="toggleOption(item)"
                                        )
                                            template(v-if="item.translationOrigin")
                                                span.circle.fi.fis(
                                                    v-if="item.translationOrigin.color"
                                                    :style="{ backgroundColor: item.translationOrigin.color }"
                                                )
                                                span.text-gray {{ item.color }}
                                            template(v-else)
                                                span.circle.fi.fis(
                                                    v-if="item.color"
                                                    :style="{ backgroundColor: item.color }"
                                                )
                                                span.text-gray {{ item.color }}
                                        td.event-listener(
                                            @mouseover="hover"
                                            @mouseout="blur"
                                            @click.prevent.stop="toggleOption(item)"
                                        ) {{ item.value }}
                                        //- The product's own price for the option wins over the option's default.
                                        td.surcharge.event-listener(
                                            @mouseover="hover"
                                            @mouseout="blur"
                                            @click.prevent.stop="toggleOption(item)"
                                        )
                                            el-tooltip(v-if="surchargeDiffers(attachedOrItem(item))" placement="top")
                                                template(#content)
                                                    .surcharge-groups
                                                        div(v-for="line in surchargeLines(attachedOrItem(item))" :key="line.id") {{ line.text }}
                                                span.differs {{ optionSurcharge(item) }}
                                            template(v-else) {{ optionSurcharge(item) }}
                                        td.event-listener(
                                            @mouseover="hover"
                                            @mouseout="blur"
                                            @click.prevent.stop="toggleOption(item)"
                                        ) {{ item.addition }}
                                        td.event-listener(
                                            @mouseover="hover"
                                            @mouseout="blur"
                                            @click.prevent.stop="toggleOption(item)"
                                        ) {{ item.description }}
                                        td.event-listener(
                                            v-if="valueOptionGroupsFeatureEnabled"
                                            @mouseover="hover"
                                            @mouseout="blur"
                                            @click.prevent.stop="toggleOption(item)"
                                        ) {{ item.group }}
                                        template(v-if="!modal.form.property.article_required")
                                            td.actions(v-if="isActiveOption(item)")
                                                el-button.action.icon-only(
                                                    size="mini"
                                                    type="text"
                                                    @click="editValueOption(item)"
                                                )
                                                    i.el-icon-fa-pencil.fas
                                            td.actions.event-listener(
                                                v-else
                                                @mouseover="hover"
                                                @mouseout="blur"
                                                @click.prevent.stop="toggleOption(item)"
                                            )
                            .options-loading-more(v-if="modal.loadingMore")
                                i.el-icon-loading
                                span {{ $t('Loading more options') }}
                            //- el-button.add-value-option(
                            //-     v-if="!activeTranslation"
                            //-     type="primary"
                            //-     icon="el-icon-fa-plus fas"
                            //-     @click="addValueOption"
                            //- ) {{ $t('Add property value') }}

                el-form.property-modal-form(
                    v-else-if="modal.type === 'value-option-form'"
                    key="value-option-form"
                    :model="modal.form.valueOption"
                    label-position="top"
                    :rules="modalRules"
                    ref="modal"
                    v-loading="modal.loading"
                    @submit.prevent.native="submitModalForm"
                )
                    //- el-form-item(:label="$t('Value')" prop="value")
                    //-     el-date-picker.is-full-width(
                    //-         v-if="modal.form.property.propType && modal.form.property.propType.key === 'date'"
                    //-         prefix-icon="far el-icon-fa-calendar-alt"
                    //-         :format="getDateformat(modal.form.property)"
                    //-         :type="modal.form.property.datetype"
                    //-         :picker-options="{ firstDayOfWeek: 1 }"
                    //-         @input="addDateOption"
                    //-     )
                    //-     el-input.is-full-width(
                    //-         v-if="!(modal.form.property.propType && modal.form.property.propType.key === 'date')"
                    //-         v-model="modal.additionalOptionValue"
                    //-         :type="modal.additionalOptionType"
                    //-         @keydown.escape.native="resetNewOption"
                    //-         @keydown.enter.native.prevent="event => addNewOption()"
                    //-     )
                    //-         i.unit(
                    //-             v-if="modal.form.property.propType && modal.form.property.propType.key === 'unit' && modal.form.property.unit"
                    //-             slot="suffix"
                    //-         ) {{ modal.form.property.unit }}
                    PropertyValueOptionForm(
                        :value-option="modal.form.valueOption"
                        :prop-type="modal.form.property.propType"
                        :property="modal.form.property"
                        :date-format="getDateformat(modal.form.property)"
                        :options="options"
                        :hide-main-tab="modal.form.valueOption.id && !isNaN(modal.form.valueOption.id)"
                        :inherited-tax="tax"
                    )

                el-form.property-modal-form(
                    v-else-if="modal.type === 'add'"
                    key="add"
                    :model="modal.form"
                    label-position="top"
                    :rules="modalRules"
                    ref="modal"
                    v-loading="modal.loading"
                    @submit.prevent.native="submitModalForm"
                )
                    transition(:name="modal.transition" mode="out-in")
                        el-tabs(
                            v-if="! modal.loading"
                            v-model="modal.tab"
                            tab-position="left"
                            @tab-click="resetModalTab"
                        )
                            el-tab-pane(:label="$t('Existing attributes')" name="existing")
                                el-alert(
                                    v-if="! options.property.items.length"
                                    :title="$t('There are no attributes yet.')"
                                    :closable="false"
                                )
                                //- The box has to survive its own results: a search with no hit
                                //- must not take the search box away with it.
                                el-form-item.property-search(v-if="options.property.items.length > 8 || modal.propertyFilter")
                                    el-input(
                                        ref="propertySearch"
                                        v-model="modal.propertyFilter"
                                        v-focus
                                        clearable
                                        prefix-icon="el-icon-fa-search fas"
                                        :placeholder="$t('Search attributes')"
                                    )
                                el-alert(
                                    v-if="options.property.items.length && !filteredPropertyItems.length"
                                    :title="$t('No attribute matches the search.')"
                                    :closable="false"
                                )
                                el-button.property-button(
                                    v-for="item in filteredPropertyItems" :key="item.id"
                                    :plain="item.id !== modal.property.id"
                                    :type="isInProduct(item) || item.id === modal.property.id ? 'primary' : ''"
                                    :icon="item.article_required ? 'el-icon-fa-tasks fas' : 'el-icon-fa-tag fas'"
                                    :disabled="isInProduct(item)"
                                    @click="selectProperty(item)"
                                )
                                    .property-label
                                        p.name {{ item.name }}
                                        small.meta
                                            code.key(v-if="item.key") {{ item.key }}
                                            span.dot(v-if="item.key") ·
                                            span.type {{ $t(item.propType.key) }}
                            el-tab-pane(:label="$t('New attribute')" name="new")
                                div(v-if="modal.tab === 'new'")
                                    el-form-item(:label="$t('Name')" prop="property.name")
                                        el-input(v-model="modal.form.property.name" autocomplete="off" v-focus)
                                    el-form-item(:label="$t('Key')" prop="property.key")
                                        el-input(v-model="modal.form.property.key" autocomplete="off")
                                    el-form-item(:label="$t('Property type')" prop="property.propType")
                                        el-input.loading(
                                            v-if="modal.form.property.propType && options.propType.loading"
                                            :value="$t(modal.form.property.propType.key)"
                                            :disabled="true"
                                        )
                                        el-select.is-full-width(
                                            v-else
                                            placeholder="" v-model="modal.form.property.propType" valueKey="id"
                                            :class="{ 'loading': options.propType.loading }"
                                        )
                                            el-option(
                                                v-for="item in options.propType.items"
                                                :key="item.id"
                                                :label="$t(item.key)"
                                                :value="item"
                                                :disabled="(item.key === 'input' && !propTypeInputFeatureEnabled) || (item.key === 'upload' && !propTypeUploadFeatureEnabled)"
                                            )
                                    transition(:name="modal.transition" mode="out-in")
                                        el-form-item(
                                            :label="$t('Date type')" prop="property.datetype"
                                            v-if="modal.form.property.propType && modal.form.property.propType.key === 'date'"
                                        )
                                            el-select.is-full-width(placeholder="" v-model="modal.form.property.datetype")
                                                el-option(
                                                    v-for="(item, key) in options.dateType.items"
                                                    :key="key"
                                                    :label="$t(item.label)"
                                                    :value="item.value"
                                                )
                                        el-form-item(
                                            :label="$t('Unit name')" prop="property.dateType"
                                            v-else-if="modal.form.property.propType && modal.form.property.propType.key === 'unit'"
                                        )
                                            el-input(
                                                :placeholder="$t('e.g. kg, ltr, cm, ...')"
                                                v-model="modal.form.property.unit"
                                            )
                                    transition(:name="modal.transition")
                                        el-form-item(v-if="modal.form.property.propType && modal.form.property.propType.key !== 'input' && modal.form.property.propType.key !== 'upload'")
                                            el-switch(
                                                :active-text="$t('Leads to additional articles with inventory and extensive setting options.')"
                                                inactive-color="#ff4949"
                                                v-model="modal.form.property.article_required"
                                            )

            template(slot="footer" v-if="modal.type === 'edit'")
                .flex-row
                    .left
                        el-button.add-value-option(
                            v-if="!activeTranslation"
                            type="primary"
                            icon="el-icon-fa-plus fas"
                            @click="showNewValueOptionForm"
                        ) {{ $t('Add property value') }}
                    .grow
                    .right
                        el-button(
                            icon="el-icon-fa-times fas"
                            @click="closeModal"
                        ) {{ $t('Dismiss') }}
                        el-button(
                            :disabled="modal.loading"
                            type="primary"
                            icon="el-icon-fa-check fas"
                            @click="submitModalForm"
                        ) {{ $t('Ok') }}

            template(slot="footer" v-if="modal.type === 'value-option-form'")
                .flex-row
                    .left
                        el-button.add-value-option(
                            v-if="!activeTranslation"
                            icon="el-icon-fa-arrow-left fas"
                            @click="handleModalBackButton"
                        ) {{ $t('Back') }}
                    .grow
                    .right
                        //- el-button(
                        //-     icon="el-icon-fa-times fas"
                        //-     @click="closeModal"
                        //- ) {{ $t('Dismiss') }}
                        el-button(
                            :disabled="modal.loading"
                            type="primary"
                            icon="el-icon-fa-check fas"
                            @click="event => addNewOption()"
                        ) {{ $t('Ok') }}

            template(slot="footer" v-else-if="modal.type === 'add' || modal.type === 'pending'")
                el-button(
                    icon="el-icon-fa-times fas"
                    @click="closeModal"
                ) {{ $t('Dismiss') }}
                el-button(
                    v-if="(modal.tab === 'new' && modal.form.property.propType && (modal.form.property.propType.key === 'input' || modal.form.property.propType.key === 'upload')) || (modal.tab === 'existing' && modal.property.propType && (modal.property.propType.key === 'input' || modal.property.propType.key === 'upload'))"
                    :disabled="modal.loading"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    @click="submitModalForm"
                ) {{ $t('Ok') }}
                el-button(
                    v-else-if="modal.tab === 'new'"
                    :disabled="modal.loading"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    @click="changeModalToOptions"
                ) {{ $t('Next') }}
                el-button(
                    v-else-if="modal.tab === 'existing'"
                    :disabled="modal.loading || ! modal.property.id"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    @click="changeModalToOptions"
                ) {{ $t('Next') }}
</template>

<i18n>
{
    "en": {
        "text": "Text",
        "number": "Number",
        "date": "Date",
        "unit": "Unit",
        "color": "Color",
        "input": "User input",
        "upload": "File upload",
        "{count} new": "{count} new",
        "{combinations} = {total} variants": "{combinations} = {total} variants",
        "{count} chosen": "{count} chosen",
        "{count} values": "{count} values",
        "{from} to {to}": "{from} to {to}",
        "{amount} for this product": "{amount} for this product",
        "That makes {total} articles, one for each combination. Each one has its own article number, stock and price.": "That makes {total} articles, one for each combination. Each one has its own article number, stock and price.",
        "Saving adds {added} articles to the {existing} the product already has.": "Saving adds {added} articles to the {existing} the product already has.",
        "Loading more options": "Loading more options",
        "Depends on {property}": "Depends on {property}",
        "Depends on {property}, which is not attached to this product. It is shown without condition.": "Depends on {property}, which is not attached to this product. It is shown without condition."
    },
    "de": {
        "Depends on {property}": "Hängt von {property} ab",
        "Depends on {property}, which is not attached to this product. It is shown without condition.": "Hängt von {property} ab, die diesem Produkt nicht zugeordnet ist. Sie wird ohne Bedingung angezeigt.",
        "Dissolve by attribute": "Nach Attribut auflösen",
        "Dissolve": "Auflösen",
        "This will create a separate product for each value of this attribute. The original product will be disabled. This action cannot be undone.": "Es wird ein separates Produkt für jeden Wert dieses Attributs erstellt. Das Originalprodukt wird deaktiviert. Diese Aktion kann nicht rückgängig gemacht werden.",
        "Product dissolved successfully.": "Produkt erfolgreich aufgelöst.",
        "An error occurred while dissolving the product.": "Beim Auflösen des Produkts ist ein Fehler aufgetreten.",
        "Next": "Weiter",
        "Property Set": "Attributset",
        "New product attribute": "Neues Attribut",

        "Filter options": "Optionen filtern",
        "Search options": "Optionen suchen",
        "Search attributes": "Attribute suchen",
        "Surcharge": "Aufpreis",
        "{from} to {to}": "{from} bis {to}",
        "no surcharge": "kein Aufpreis",
        "{amount} for this product": "{amount} für dieses Produkt",
        "No attribute matches the search.": "Kein Attribut passt zur Suche.",
        "{count} new": "{count} neu",
        "{combinations} = {total} variants": "{combinations} = {total} Varianten",
        "{count} chosen": "{count} gewählt",
        "{count} values": "{count} Werte",
        "That makes {total} articles, one for each combination. Each one has its own article number, stock and price.": "Das ergibt {total} Artikel, einen je Kombination. Jeder hat eine eigene Artikelnummer, eigenen Bestand und eigenen Preis.",
        "Saving adds {added} articles to the {existing} the product already has.": "Beim Speichern kommen {added} Artikel zu den {existing} vorhandenen dazu.",
        "The product already has all of them.": "Alle davon gibt es schon.",
        "What does this mean?": "Was bedeutet das?",
        "Loading more options": "Weitere Optionen werden geladen",
        "Add option": "Option hinzufügen",

        "Add attribute": "Attribut hinzufügen",
        "The articles will be regenerated because the attributes have changed.": "Die Artikel werden neu generiert, da sich die Attribute geändert haben.",

        "Can be configured by the customer.": "Kann vom Kunden konfiguriert werden.",
        "Leads to additional articles with inventory and extensive setting options.": "Führt zu zusätzlichen Artikeln mit Bestand und umfangreichen Einstellungsmöglichkeiten.",
        "Product attribute": "Produktattribut",
        "Existing attributes": "Bestehende Attribute",
        "There are no attributes yet.": "Es gibt noch keine Attribute.",
        "New attribute": "Neues Attribut",
        "Property type": "Art des Attributs",
        "Date type": "Art des Datums",
        "Key": "Eindeutige Kennung",
        "Unit name": "Bezeichnung der Einheit",
        "e.g. kg, ltr, cm, ...": "z.B. kg, ltr, cm, ...",
        "Attribute dependencies could not be fetched.": "Attributabhängigkeiten konnten nicht abgerufen werden.",
        "Add property value": "Attributwert hinzufügen",
        "Select existing value": "Existierenden Wert auswählen",
        "Back": "Zurück",

        "Image": "Bild",
        "Color": "Farbe",
        "Value": "Wert",
        "Addition": "Zusatz",
        "Description": "Beschreibung",
        "Group": "Gruppierung",

        "text": "Text",
        "number": "Zahl",
        "date": "Datum",
        "unit": "Einheit",
        "color": "Farbe",
        "input": "Benutzereingabe",
        "upload": "Datei-Upload"
    }
}
</i18n>

<script>
import _ from 'lodash';
import { format, getUnixTime, fromUnixTime } from 'date-fns';
import { timestamp2date, moneyFormat } from '@/filters';
import { isNumeric } from '@/helpers';

import draggable from 'vuedraggable';
import uniqid from 'uniqid';
import Fuse from 'fuse.js';

import pinia from '@/pinia';
import { useSetupStore, useShopProductStore } from '@/stores';

import PropertyValueOptionForm from '@/extensions/shop/views/Property/Form/Partials/PropertyValueOptionForm';

import PropertyApi from '@/extensions/shop/store/api/property';
import { cleanup } from '@/filters';

// How many options the picker holds at once. Past this it searches on the server
// instead, which is the only way a property with thousands of them stays openable.
const OPTION_SLICE_SIZE = 100;

export default {
    name: 'Properties',
    props: {
        form: {
            type: Object,
            required: true,
        },
        initialProduct: {
            type: Object,
            required: false,
        },
        rules: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            modal: {
                visibility: false,
                loading: false,
                transition: null,

                tab: 'existing',
                type: 'edit',
                title: this.$t('Product attribute'),
                filter: '',
                propertyFilter: '',

                additionalOptionValue: undefined,
                additionalOptionType: 'text',

                pending: false,

                options: [],
                // Whether the list on screen is a slice of a bigger set, and therefore
                // whether typing has to reach the server rather than filter locally.
                searchable: false,
                page: 1,
                lastPage: 1,
                loadingMore: false,
                property: {},

                form: {
                    property: {
                        key: '',
                        name: '',
                        unit: '',
                        datetype: 'date',
                        article_required: true,
                        propType: undefined,
                    },
                    valueOption: {
                        key: undefined,
                        position: null,
                        text: undefined,
                        image: undefined,
                        color: undefined,
                        date: undefined,
                        number: undefined,
                        addition: undefined,
                        description: undefined,
                        group: undefined,
                        value: undefined,
                    },
                    valueOptions: [],
                },
            },
            optionSearchTimer: null,
            // usedKeys: [],
            dissolveModal: {
                visibility: false,
                loading: false,
                propertyPivot: null,
            },
        };
    },
    components: {
        draggable,
        PropertyValueOptionForm,
    },
    filters: {
        cleanup,
    },
    watch: {
        'modal.type'() {
            this.focusModalSearch();
        },
        'modal.form.property.name'(value) {
            if (!value) {
                this.modal.form.property.key = '';
                return;
            }

            const requestedKey = _.kebabCase(value);
            let key = requestedKey;

            var i = 0;
            const usedKeys = this.options.property.items.map((el) => el.key);
            while (usedKeys.includes(key)) {
                ++i;
                key = `${requestedKey}-${i}`;
            }

            this.modal.form.property.key = key;
        },
    },
    computed: {
        activeTranslation() {
            if (this.form.translationOrigin) return this.form;
        },
        propTypeInputFeatureEnabled() {
            let features = _.get(this.activeCms, 'config.template.features') || [];
            return !!features.find((el) => el === 'prop-type:input');
        },
        propTypeUploadFeatureEnabled() {
            let features = _.get(this.activeCms, 'config.template.features') || [];
            return !!features.find((el) => el === 'prop-type:upload');
        },
        valueOptionGroupsFeatureEnabled() {
            const features = _.get(this.activeCms, 'config.template.features') || [];
            return features.includes('property-value-options:groups');
        },
        propertyConditionsFeatureEnabled() {
            const features = _.get(this.activeCms, 'config.template.features') || [];
            return features.includes('property:conditions');
        },
        tax() {
            const price = this.form.prices.find((el) => el.type === 'main');
            let tax = _.get(price, 'tax');
            if (!tax) {
                const taxRate = _.get(price, 'tax_rate') || 'regular';
                // tax = this.options.tax.items.find(el => {
                //     if (taxRate === 'regular' && el.default) return el
                //     else if (taxRate === 'reduced' && el.reduced) return el
                // })

                if (taxRate === 'regular') tax = _.get(this.activeShop, 'defaultTax');
                else if (taxRate === 'reduced') tax = _.get(this.activeShop, 'defaultReducedTax');
            }
            return tax;
        },
        propertyPivots: {
            get() {
                const propertyPivots = _.cloneDeep(this.form.propertyPivots) || [];

                return propertyPivots
                    .map((el) => {
                        el.valueOptions.map((el) => {
                            if (el.id && isNumeric(el.id)) el.id = parseInt(el.id);
                            if (!el.position) el.position = 0;
                            return el;
                        });

                        el.valueOptions = _.sortBy(el.valueOptions, ['position', 'id']);
                        return el;
                    })
                    .filter((el) => el.property != null);
            },
            set(value) {
                let propertyPivots = _.cloneDeep(value);
                propertyPivots.forEach((el, i) => (el.position = i + 1));
                this.setPropertyPivots(propertyPivots);
            },
        },
        propSet: {
            get() {
                return this.form.propSet;
            },
            set(propSet) {
                this.setPropSet(propSet);

                let propertyPivots = this.form.propertyPivots
                    .filter((pivot) => {
                        const match = !!propSet.properties.find((el) => el.id === pivot.property.id);
                        return match || (pivot.valueOptions && pivot.valueOptions.length);
                    })
                    .map((el) => {
                        el.property.default = false;
                        return el;
                    });

                // add all PropSet related properties to form
                // look for already existing properties
                propSet.properties.forEach((property) => {
                    const match = propertyPivots.find((el) => el.property.id === property.id);
                    if (!match) {
                        let propertyPivot = { id: uniqid('new:'), property, valueOptions: [] };
                        propertyPivot.property.default = true;
                        propertyPivots.push(propertyPivot);
                    } else match.property.default = true;
                });

                this.setPropertyPivots(propertyPivots);
            },
        },
        selectedValueOptions() {
            const selected = _.get(this.modal, 'form.valueOptions') || [];

            return selected.map((selection) => {
                const full = this.modal.options.find((el) => el.id == selection.id);

                return full || selection;
            });
        },

        // n colours x m sizes = the articles this product will end up with. Only
        // article-defining properties multiply, so the rest are left out of it.
        variantConsequence() {
            if (!_.get(this.modal, 'form.property.article_required')) return null;

            const pivots = _.get(this.form, 'propertyPivots') || [];
            const chosen = Math.max(this.selectedValueOptions.length, 0);
            if (!chosen) return null;

            let total = chosen;
            let names = [chosen];
            const parts = [{ name: _.get(this.modal, 'form.property.name'), count: chosen, current: true }];

            pivots.forEach((pivot) => {
                if (!_.get(pivot, 'property.article_required')) return;
                if (pivot.deleted) return;
                if (_.get(pivot, 'property.id') == _.get(this.modal, 'form.property.id')) return;

                const count = (pivot.valueOptions || []).length;
                if (!count) return;

                total *= count;
                names.push(count);
                parts.push({ name: _.get(pivot, 'property.name'), count, current: false });
            });

            const existing = (_.get(this.form, 'articles') || []).filter((el) => !el.deleted).length;

            return {
                summary: this.$t('{combinations} = {total} variants', {
                    combinations: names.join(' × '),
                    total,
                }),
                added: existing && total > existing ? total - existing : 0,
                total,
                existing,
                parts,
            };
        },

        // The shop's properties narrowed by the search box of the "existing" tab:
        // name, key and type, the way the option search works below.
        filteredPropertyItems() {
            const filter = _.trim(this.modal.propertyFilter);
            const items = this.options.property.items || [];
            if (!filter) return items;

            const fuse = new Fuse(items, {
                shouldSort: true,
                tokenize: true,
                matchAllTokens: true,
                threshold: 0.3,
                minMatchCharLength: 1,
                keys: ['name', 'key', 'propType.key'],
            });

            return fuse.search(filter).map((element) => element.item);
        },
        filteredOptions() {
            let highlight = this.modal.additionalOptionValue;
            const filter = _.trim(this.modal.filter);

            const settings = {
                shouldSort: true,
                tokenize: true,
                matchAllTokens: true,
                threshold: 0.3,
                minMatchCharLength: 1,
                keys: ['value'],
            };

            if (highlight != null) {
                highlight = _.trim(highlight);
                const fuse = new Fuse(this.modal.options, settings);
                const result = fuse.search(highlight);

                const values = result.map((el) => el.item.value);

                let options = _.cloneDeep(this.modal.options);
                return options.map((el) => {
                    if (el.value === highlight) el.match = true;
                    else if (values.includes(el.value)) el.highlight = true;
                    return el;
                });
            } else if (filter) {
                const fuse = new Fuse(this.modal.options, settings);
                const result = fuse.search(filter);

                return result.map((el) => el.item);
            } else {
                return this.modal.options;
            }
        },
        modalRules() {
            let rules = {
                property: {},
            };

            const propType = this.modal.form.property.propType;

            if (this.modal.type === 'add' && this.modal.tab === 'new') {
                const exclude = this.options.property.items.map((el) => el.key).join(',');

                rules.property.name = 'required|min:3';
                rules.property.key = `required|key|excluded:${exclude}`;
                rules.property.propType = 'required';

                if (propType && propType.key === 'date') {
                    rules.property.datetype = 'required';
                }
            }

            if (this.modal.type === 'value-option-form') {
                let exclude = this.modal.options
                    .filter((el) => el.id != this.modal.form.valueOption.id)
                    .map((el) => el[propType.value_field])
                    .join(',');

                const propertyID = _.get(this.modal.form.property, 'id');
                const valueOptionID = _.get(this.modal.form.valueOption, 'id');

                // The remote check needs a saved property to ask about, and a saved
                // option to exclude from the answer.
                let keyRule = 'required|key';
                if (propertyID && !_.startsWith(String(propertyID), 'new:')) {
                    keyRule += `|unique_property_value_option_key:"property":${propertyID}`;
                    if (valueOptionID && !_.startsWith(String(valueOptionID), 'new:')) {
                        keyRule += `,"valueOption":${valueOptionID}`;
                    }
                }

                rules = {
                    [propType.value_field]: `required|excluded:${exclude}`,
                    key: keyRule,
                };
            }

            return rules;
        },
        articlesMustBeRegenerated() {
            if (!this.initialProduct) return false;

            const initialArticlePropertyPivots = _.get(this.initialProduct, 'propertyPivots', []).filter(
                (el) => el.property.article_required
            );

            const actualArticlePropertyPivots = _.get(this.form, 'propertyPivots', []).filter(
                (el) => !el.deleted && el.property.article_required
            );

            // return _.isEqual(initialArticlePropertyPivots, actualArticlePropertyPivots) === false

            if (initialArticlePropertyPivots.length !== actualArticlePropertyPivots.length) return true;

            const initialArticlePropertyPivotIDs = initialArticlePropertyPivots.map((el) => el.property.id).sort();
            const actualArticlePropertyPivotIDs = actualArticlePropertyPivots.map((el) => el.property.id).sort();
            if (!_.isEqual(initialArticlePropertyPivotIDs, actualArticlePropertyPivotIDs)) return true;

            // const initialArticlePropertyPivotValueOptions = initialArticlePropertyPivots.map(el => el.valueOptions.map(el => el.valueOption)).sort()
            let initialArticlePropertyPivotValueOptions = {};
            initialArticlePropertyPivots.forEach((el) => {
                initialArticlePropertyPivotValueOptions[el.property.id] = el.valueOptions.map((el) => el.id).sort();
            });

            let actualArticlePropertyPivotValueOptions = {};
            actualArticlePropertyPivots.forEach((el) => {
                actualArticlePropertyPivotValueOptions[el.property.id] = el.valueOptions
                    .map((el) => el.id || uniqid('new:'))
                    .sort();
            });

            if (!_.isEqual(initialArticlePropertyPivotValueOptions, actualArticlePropertyPivotValueOptions))
                return true;

            return false;
        },
        activeShop() {
            return this.activeCms.shop;
        },
        setupStore() {
            return useSetupStore();
        },
        shopProductStore() {
            return useShopProductStore(pinia);
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        options() {
            return this.shopProductStore.options;
        },
    },
    methods: {
        sortPropertyPivotValueOptions(event, propertyPivot) {
            propertyPivot = _.cloneDeep(propertyPivot);

            const { newIndex, oldIndex } = event;
            const valueOptions = propertyPivot.valueOptions;

            const valueOption = valueOptions.splice(oldIndex, 1)[0];
            valueOptions.splice(newIndex, 0, valueOption);
            valueOptions.forEach((el, i) => (el.position = i + 1));

            this.setFormPropertyPivot(propertyPivot);
        },
        isInProduct(property) {
            let isInProduct = false;

            const id = _.get(property, 'id');
            isInProduct = !!this.form.propertyPivots.find((el) => el.property.id === id);

            return isInProduct;
        },
        selectProperty(property) {
            this.modal.property = property;
        },

        // Above a few hundred options the browser stops filtering a full copy of the
        // set and asks the server for the matches instead.
        // One page of the property's options. Appending rather than replacing is what
        // makes the scroll continuous; page 1 replaces so a new search starts clean.
        fetchOptionPage(page = 1) {
            const propID = _.get(this.modal, 'form.property.id');
            if (!propID || String(propID).startsWith('new:')) return Promise.resolve();

            const term = _.trim(this.modal.filter);
            const filters = term ? [{ key: 'search', like: term }] : [];

            this.$set(this.modal, 'loadingMore', page > 1);

            return PropertyApi.fetchValueOptionsPaginated({
                property: parseInt(propID),
                currentPage: page,
                perPage: OPTION_SLICE_SIZE,
                filters,
                scope: 'ex',
                type: 'shop_property_value_option',
            })
                .then((result) => {
                    const items = _.get(result, 'items') || [];
                    const merged = page > 1 ? [...this.modal.options, ...items] : items;

                    this.$set(this.modal, 'options', merged);
                    this.$set(this.modal, 'page', _.get(result, 'pageInfo.currentPage') || page);
                    this.$set(this.modal, 'lastPage', _.get(result, 'pageInfo.lastPage') || 1);
                    this.$set(this.modal, 'searchable', (_.get(result, 'pageInfo.total') || 0) > OPTION_SLICE_SIZE);
                })
                .finally(() => this.$set(this.modal, 'loadingMore', false));
        },

        // The list the modal holds is a slice, so searching cannot be a client-side
        // filter over it - the match may well be on the part that was never loaded.
        onOptionSearch() {
            if (!this.modal.searchable) return;

            clearTimeout(this.optionSearchTimer);
            this.optionSearchTimer = setTimeout(() => this.fetchOptionPage(1), 300);
        },

        onOptionsScroll(event) {
            if (this.modal.loadingMore) return;
            if (this.modal.page >= this.modal.lastPage) return;

            const el = event.target;
            if (el.scrollTop + el.clientHeight < el.scrollHeight - 120) return;

            this.fetchOptionPage(this.modal.page + 1);
        },

        toggleOption(valueOption) {
            if (valueOption === 'all') {
                // Select or deselect all options
                const allSelected = this.modal.options.every((option) => this.isActiveOption(option));
                this.modal.options.forEach((option) => {
                    const isActive = this.isActiveOption(option);
                    if (allSelected) {
                        // Deselect all
                        if (isActive) {
                            const index = this.modal.form.valueOptions.findIndex((el) => el.id == option.id);
                            if (index >= 0) this.$delete(this.modal.form.valueOptions, index);
                        }
                    } else {
                        // Select all
                        if (!isActive) {
                            this.$set(this.modal.form.valueOptions, this.modal.form.valueOptions.length, option);
                        }
                    }
                });
            } else {
                // Toggle individual option
                const index = this.modal.form.valueOptions.findIndex((el) => el.id == valueOption.id);
                if (index >= 0) {
                    this.$delete(this.modal.form.valueOptions, index);
                } else {
                    this.$set(this.modal.form.valueOptions, this.modal.form.valueOptions.length, valueOption);
                }
            }
        },

        isActiveOption(valueOption) {
            return !!this.modal.form.valueOptions.find((el) => el.id == valueOption.id);
        },

        setPropSet(propSet) {
            // this.$store.commit('ext_shop_product/form/propSet', propSet)
            this.setFormPropSet(propSet);
        },
        setPropertyPivot(propertyPivot) {
            // this.$store.commit('ext_shop_product/form/propertyPivot', propertyPivot)
            propertyPivot = _.cloneDeep(propertyPivot);
            // propertyPivot.valueOptions = _.orderBy(this.modal.form.valueOptions, 'value', 'asc')
            propertyPivot.valueOptions = this.modal.form.valueOptions;
            this.setFormPropertyPivot(propertyPivot);
        },
        setPropertyPivots(propertyPivots) {
            // this.$store.commit('ext_shop_product/form/propertyPivots', propertyPivots)
            this.setFormPropertyPivots(propertyPivots);
        },
        // eslint-disable-next-line
        getPropertyHexValue(pivot) {
            // TODO
            return false;
        },
        // The surcharge an option adds on this product, one entry per customer group of
        // the shop: the product's own price for the group wins over the option's default
        // for that group; a group without either pays no surcharge, like the API resolves
        // it. Falls back to the single resolved price when the lists were not loaded.
        surchargesByGroup(valueOption) {
            const groups = _.get(this.options, 'customerGroup.items') || [];
            const pivotPrices = _.get(valueOption, 'pivot.prices');
            const optionPrices = _.get(valueOption, 'prices');

            if (!groups.length || (!pivotPrices && !optionPrices)) {
                const value = _.get(valueOption, 'pivot.price.value') || _.get(valueOption, 'price.value') || null;
                return value === null ? [] : [{ id: 'resolved', name: '', value, own: !!_.get(valueOption, 'pivot.price.value') }];
            }

            const priceFor = (prices, group) =>
                (prices || []).find((price) => String(_.get(price, 'customerGroup.id')) === String(group.id));

            return groups.map((group) => {
                const own = priceFor(pivotPrices, group);
                const price = own || priceFor(optionPrices, group);
                return { id: group.id, name: group.name, value: price ? price.value : null, own: !!own };
            });
        },
        formatSurcharge(value) {
            const currency = _.get(this.activeShop, 'defaultCustomerGroup.currency.iso4217') || 'EUR';
            // a discount carries its minus already
            return (value > 0 ? '+' : '') + moneyFormat(value, currency);
        },
        // The label on the option: one amount when every group pays the same, a range
        // when they differ. Empty when no group pays anything.
        surchargeOf(valueOption) {
            const values = this.surchargesByGroup(valueOption)
                .map((entry) => entry.value)
                .filter((value) => value !== null && value !== undefined && value !== 0);
            if (!values.length) return '';

            const lowest = Math.min(...values);
            const highest = Math.max(...values);
            if (lowest === highest) return this.formatSurcharge(lowest);

            return this.$t('{from} to {to}', { from: this.formatSurcharge(lowest), to: this.formatSurcharge(highest) });
        },
        // Whether the groups do not all pay the same, including a group that pays nothing
        // while another does: the label then carries a tooltip with every group.
        surchargeDiffers(valueOption) {
            const entries = this.surchargesByGroup(valueOption).filter((entry) => entry.id !== 'resolved');
            if (entries.length < 2) return false;
            const distinct = _.uniq(entries.map((entry) => entry.value || 0));
            return distinct.length > 1;
        },
        surchargeLines(valueOption) {
            return this.surchargesByGroup(valueOption).map((entry) => {
                let text = entry.value ? this.formatSurcharge(entry.value) : this.$t('no surcharge');
                if (entry.own) text = this.$t('{amount} for this product', { amount: text });
                return { id: entry.id, text: `${entry.name}: ${text}` };
            });
        },
        // A row of the option table may show an option that is not attached yet: then
        // only the option's own prices are known.
        attachedOrItem(item) {
            const attached = (this.modal.form.valueOptions || []).find((valueOption) => String(valueOption.id) === String(item.id));
            return attached || item;
        },
        optionSurcharge(item) {
            return this.surchargeOf(this.attachedOrItem(item));
        },
        // Whether the property that reveals this pivot's property is on the product
        // as well. Deleted pivots do not count: they are gone once saved.
        hasConditionTrigger(propertyPivot) {
            const triggerId = _.get(propertyPivot, 'property.conditionProperty.id');
            if (!triggerId) return true;

            return !!(this.propertyPivots || []).find((pivot) => {
                return !pivot.deleted && String(_.get(pivot, 'property.id')) === String(triggerId);
            });
        },
        getLabel(valueOption, property) {
            // if (property.propType.key === 'date') {
            //     const date = fromUnixTime(valueOption.date)
            //     return format(date, this.getDateformat(property));
            // } else {
            //     const valueField = property.propType.value_field
            //     return valueOption[valueField]
            // }

            let value;

            if (valueOption.translationOrigin && !['text', 'unit'].includes(property.propType.key)) {
                valueOption = valueOption.translationOrigin;
            }

            if (property.propType.key === 'date') {
                if (!valueOption.date) return null;
                value = timestamp2date(valueOption.date, this.getDateformat(property));
            } else {
                let valueField = property.propType.value_field;
                if (property.propType.valueField === 'number') value = parseFloat(valueOption.number);
                value = valueOption[valueField];
            }

            return value;
        },
        getDateformat(property) {
            let format = this.$t('yyyy-MM-dd');

            switch (property.datetype) {
                case 'datetime':
                    format = this.$t('yyyy-MM-dd') + '   HH:mm';
                    break;

                case 'week':
                    format = this.$t('yyyy Week WW');
                    break;

                case 'month':
                    format = this.$t('yyyy-MM');
                    break;

                case 'year':
                    format = this.$t('yyyy');
                    break;
            }

            return format;
        },
        openModal(propertyPivot = null) {
            if (
                _.get(propertyPivot, 'property.propType.key') === 'input' ||
                _.get(propertyPivot, 'property.propType.key') === 'upload'
            )
                return;

            this.modal.loading = true;
            this.modal.visibility = true;

            this.modal.transition = 'slide-decent-vertical';
            // setTimeout(() => this.modal.transition = 'slide-decent-vertical', 1000)

            if (propertyPivot && propertyPivot.property) {
                this.modal.title = propertyPivot.property.name;
                this.modal.form = {
                    ..._.cloneDeep(propertyPivot),
                    valueOption: this.modal.form.valueOption,
                };

                const shopID = this.activeShop.id;
                const propID = propertyPivot.property.id;
                const valueField = propertyPivot.property.propType.value_field;

                const type = ['number', 'unit'].includes(propertyPivot.property.propType.key) ? 'number' : 'text';
                this.modal.additionalOptionType = type;

                if (!_.startsWith(propID, 'new:')) {
                    let dependencies = [];

                    const addValueOptionsToModal = (valueOptions) => {
                        if (valueOptions.length) {
                            valueOptions.forEach((option) => {
                                // const value = _.get(option, valueField)
                                const value = this.getLabel(option, propertyPivot.property);

                                if (value) {
                                    const match = this.modal.options.find((el) => el.id == option.id);
                                    if (!match) {
                                        option.value = _.toString(value);
                                        // delete option.id

                                        // this.modal.options.push(option)
                                        this.$set(this.modal.options, this.modal.options.length, option);
                                    } else if (option.pivot != null) {
                                        this.$set(match, 'pivot', option.pivot);
                                    }
                                }
                            });
                        }

                        this.modal.form.valueOptions.forEach((option) => {
                            const value = option.value || this.getLabel(option, propertyPivot.property);
                            const match = this.modal.options.find((el) => el.id == option.id);

                            if (!match) {
                                let item = {
                                    id: option.id,
                                    key: option.key || null,
                                    text: null,
                                    description: null,
                                    addition: null,
                                    group: null,
                                    number: null,
                                    date: null,
                                    color: null,
                                    value: _.toString(value),
                                    position: this.modal.options.length + 1,
                                    pivot: undefined,
                                };
                                item[valueField] = value;

                                this.$set(this.modal.options, this.modal.options.length, item);
                            } else if (option.pivot != null) {
                                this.$set(match, 'pivot', option.pivot);
                            }
                        });
                    };

                    // The first page, not the set. A property can hold five figures'
                    // worth of options and the picker used to ask for every one of
                    // them; the rest arrive as the list is scrolled.
                    const fetchValueOptions = this.fetchOptionPage(1).then(() =>
                        addValueOptionsToModal(this.modal.options)
                    );
                    dependencies.push(fetchValueOptions);

                    if (propertyPivot.id && !propertyPivot.id.startsWith('new:')) {
                        const fetchProductPropertyPivot = PropertyApi.fetchProductPropertyPivot(propertyPivot.id).then(
                            ({ valueOptions }) => addValueOptionsToModal(valueOptions)
                        );
                        dependencies.push(fetchProductPropertyPivot);
                    }

                    Promise.all(dependencies)
                        .catch((err) => {
                            this.modal.visibility = false;

                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);

                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Attribute dependencies could not be fetched.'),
                                iconClass: 'fas el-icon-fa-times-circle',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000,
                            });
                        })
                        .finally(() => {
                            this.modal.options.map((el) => {
                                if (el.id && isNumeric(el.id)) el.id = parseInt(el.id);
                                if (!el.position) el.position = 0;
                                return el;
                            });

                            this.modal.options = _.sortBy(this.modal.options, ['position', 'id']);
                            this.modal.loading = false;

                            if (!this.modal.options.length) {
                                this.showNewValueOptionForm();
                            }
                        });
                } else {
                    // this.modal.options = _.orderBy(this.modal.form.valueOptions, 'value', 'asc')
                    this.modal.options = _.cloneDeep(this.modal.form.valueOptions);
                    this.modal.loading = false;

                    if (!this.modal.options.length) {
                        this.showNewValueOptionForm();
                    }
                }
            } else {
                // new property pivot

                this.modal.type = 'add';
                this.modal.title = this.$t('New product attribute');

                const fetchOptions = () =>
                    Promise.all([
                        this.fetchPropertyOptions(this.activeShop.id),
                        this.fetchPropTypeOptions(),
                        // PropertyApi.fetchKeys(this.activeShop.id, false)
                    ]);

                fetchOptions()
                    .then(() => {
                        const usedProperties = _.filter(this.options.property.items, (property) =>
                            this.isInProduct(property)
                        );
                        if (
                            !this.options.property.items.length ||
                            this.options.property.items.length <= usedProperties.length
                        ) {
                            this.modal.tab = 'new';
                        }
                    })
                    .catch((err) => {
                        this.modal.visibility = false;

                        /* eslint no-console: ["error", { allow: ["error"] }] */
                        console.error(err);

                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            message: this.$t('Attribute dependencies could not be fetched.'),
                            iconClass: 'fas el-icon-fa-times-circle',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000,
                        });
                    })
                    .finally(() => {
                        setTimeout(() => (this.modal.loading = false), 0);
                    });
            }
        },
        // addValueOption() {
        //     this.drawer.form = {
        //         id: uniqid('new:'),
        //         position: this.valueOptions.length + 1,
        //         image: undefined,
        //         color: undefined,
        //         date: undefined,
        //         number: undefined,
        //         addition: '',
        //         description: '',
        //     };
        //
        //     let exclude = this.valueOptions.map(el => el[this.propType.value_field]).join(',');
        //
        //     this.drawer.rules = {
        //         [this.propType.value_field]: `required|excluded:${exclude}`,
        //     }
        //     this.openDrawer();
        //
        //     setTimeout(() => {
        //         // this.$refs.drawer.resetFields()
        //         this.$refs.drawer.clearValidate()
        //     }, 0)
        // },
        // addDateOption(date) {
        //     const value = format(date, this.getDateformat(this.modal.form.property));
        //     this.modal.additionalOptionValue = value
        //     this.addNewOption({
        //         text: null,
        //         description: null,
        //         addition: null,
        //         number: null,
        //         date: getUnixTime(date),
        //         color: null,
        //         value
        //     })
        // },
        showNewValueOptionForm() {
            this.modal.type = 'value-option-form';

            this.$set(this.modal.form, 'valueOption', {
                id: uniqid('new:'),
                key: undefined,
                position: this.modal.options.length + 1,
                image: undefined,
                color: undefined,
                date: undefined,
                number: undefined,
                addition: undefined,
                description: undefined,
                group: undefined,
                value: '',
            });

            if (!this.modal.property.article_required) {
                this.$set(this.modal.form.valueOption, 'prices', []);
            }
        },
        editValueOption(item) {
            this.modal.type = 'value-option-form';
            this.modal.form.valueOption = _.cloneDeep(item);

            const value = this.getLabel(item, this.modal.form.property);
            this.modal.title = `${this.modal.form.property.name}: ${value}`;

            if (!this.modal.property.article_required && this.modal.form.valueOption.prices == null) {
                this.$set(this.modal.form.valueOption, 'prices', []);
            }
        },
        handleModalBackButton() {
            if (this.modal.pending === true) this.modal.type = 'add';
            else this.modal.type = 'edit';

            this.modal.title = this.modal.form.property.name;
        },
        addNewOption(item = null) {
            this.$refs.modal.validate((valid) => {
                if (valid) {
                    const propType = this.modal.form.property.propType;
                    const valueField = propType.value_field;

                    const value = _.trim(this.modal.form.valueOption[valueField]);
                    if (!value) return;

                    const i = this.modal.options.findIndex((el) => el.id == this.modal.form.valueOption.id);
                    const v = this.modal.form.valueOptions.findIndex((el) => el.id == this.modal.form.valueOption.id);

                    if (!item) {
                        item = _.cloneDeep(this.modal.form.valueOption);
                        item.value = value;

                        switch (valueField) {
                            case 'number':
                                item[valueField] = parseFloat(value);
                                break;

                            default:
                                item[valueField] = value;
                        }
                    }

                    if (i >= 0) {
                        this.$set(this.modal.options, i, item);
                        if (v >= 0) this.$set(this.modal.form.valueOptions, v, item);
                    } else {
                        // this.modal.options.push(item)
                        this.$set(this.modal.options, this.modal.options.length, item);
                        if (v < 0) this.toggleOption(item);
                    }

                    if (this.modal.type === 'value-option-form') {
                        if (this.modal.pending === true) {
                            this.addNewProperty();
                        } else {
                            this.modal.type = 'edit';
                        }
                    }
                } else {
                    this.$notify.error({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    });
                }
            });

            this.modal.additionalOptionValue = undefined;
        },
        // resetNewOption() {
        //     this.modal.additionalOptionValue = undefined
        //     // this.modal.additionalOptionType = 'text'
        // },
        resetModal() {
            this.modal = {
                visibility: false,
                loading: false,
                transition: null,

                tab: 'existing',
                type: 'edit',
                title: this.$t('Product attribute'),
                filter: '',
                propertyFilter: '',

                additionalOptionValue: undefined,
                additionalOptionType: 'text',

                pending: false,

                options: [],
                // Whether the list on screen is a slice of a bigger set, and therefore
                // whether typing has to reach the server rather than filter locally.
                searchable: false,
                page: 1,
                lastPage: 1,
                loadingMore: false,
                property: {},

                form: {
                    property: {
                        key: '',
                        name: '',
                        unit: '',
                        datetype: 'date',
                        article_required: true,
                        propType: undefined,
                    },
                    valueOption: {
                        key: undefined,
                        position: null,
                        text: undefined,
                        image: undefined,
                        color: undefined,
                        date: undefined,
                        number: undefined,
                        addition: undefined,
                        description: undefined,
                        group: undefined,
                        value: undefined,
                    },
                    valueOptions: [],
                },
            };
        },
        resetModalTab() {
            if (this.modal.tab === 'new') {
                this.modal.form.id = uniqid('new:');
                this.modal.form.property.id = uniqid('new:');
            } else {
                this.focusModalSearch();
            }
        },
        // The search box in front takes the focus: the option search when an attribute's
        // options are shown, the attribute search when the "existing" tab is in front. It
        // runs on opening the dialog, on switching views and on coming back from the "new"
        // tab; the panes are kept alive between switches, so v-focus alone fires only once.
        focusModalSearch() {
            this.$nextTick(() => {
                let search = null;
                if (this.modal.type === 'edit') search = this.$refs.optionSearch;
                else if (this.modal.type === 'add' && this.modal.tab === 'existing') search = this.$refs.propertySearch;

                if (search && typeof search.focus === 'function') search.focus();
            });
        },
        closeModal() {
            this.modal.visibility = false;
        },
        changeModalToOptions() {
            this.$refs.modal.validate((valid) => {
                if (valid) {
                    this.modal.type = 'pending';
                    // this.modal.transition = null

                    if (this.modal.tab === 'new') {
                        this.modal.title = this.modal.form.property.name;

                        setTimeout(() => {
                            this.modal.pending = true;
                            // this.modal.type = 'edit'
                            this.modal.form.valueOption.id = uniqid('new:');
                            this.modal.type = 'value-option-form';

                            // this.modal.transition = 'slide-decent-vertical'

                            this.modal.property = {};
                            this.modal.options = [];
                        }, 300);
                    } else if (this.modal.property.id) {
                        this.modal.title = this.modal.property.name;

                        setTimeout(() => {
                            this.modal.pending = true;
                            this.modal.type = 'edit';

                            // this.modal.transition = 'slide-decent-vertical'

                            this.modal.form.property = _.cloneDeep(this.modal.property);
                            this.modal.form.valueOptions = [];
                            this.modal.property = {};

                            this.openModal(this.modal.form);
                        }, 300);
                    } else {
                        this.modal.type = 'add';
                    }
                }
            });
        },
        submitModalForm() {
            if (this.modal.type === 'add' || (this.modal.type === 'edit' && this.modal.pending)) this.addNewProperty();
            else if (this.modal.type === 'edit') this.updateExistingProperty();
        },
        updateExistingProperty() {
            this.$refs.modal.validate((valid) => {
                if (valid) {
                    if (
                        (this.modal.tab === 'new' &&
                            ['input', 'upload'].includes(_.get(this.modal.form, 'property.propType.key'))) ||
                        (this.modal.tab === 'existing' &&
                            ['input', 'upload'].includes(_.get(this.modal, 'property.propType.key')))
                    ) {
                        this.modal.form.valueOptions = [];
                        this.modal.form.property.article_required = false;
                    } else {
                        // this.addNewOption()
                    }

                    let propertyPivot = this.form.propertyPivots.find((el) => el.id === this.modal.form.id);
                    if (propertyPivot) {
                        this.setPropertyPivot(propertyPivot);
                        this.closeModal();
                    }
                }
            });
        },
        addNewProperty() {
            this.$refs.modal.validate((valid) => {
                if (valid) {
                    if (
                        (this.modal.tab === 'new' &&
                            ['input', 'upload'].includes(_.get(this.modal.form, 'property.propType.key'))) ||
                        (this.modal.tab === 'existing' &&
                            ['input', 'upload'].includes(_.get(this.modal, 'property.propType.key')))
                    ) {
                        this.modal.form.valueOptions = [];
                        this.modal.form.property.article_required = false;
                    } else {
                        // this.addNewOption()
                    }

                    if (
                        this.modal.tab === 'existing' &&
                        ['input', 'upload'].includes(_.get(this.modal, 'property.propType.key'))
                    ) {
                        this.modal.form.property = this.modal.property;
                    }

                    let propertyPivot = _.cloneDeep(this.modal.form);
                    delete propertyPivot.valueOption;

                    propertyPivot.id = uniqid('new:');
                    propertyPivot.position = this.form.propertyPivots.length + 1;

                    // propertyPivot.valueOptions = _.orderBy(this.modal.form.valueOptions, 'value', 'asc')

                    // this.form.propertyPivots.push(propertyPivot)
                    const propertyPivots = _.cloneDeep(this.form.propertyPivots);
                    propertyPivots.push(propertyPivot);
                    this.setPropertyPivots(propertyPivots);

                    this.closeModal();
                }
            });
        },
        // propertyIsDeletable(property) {
        //     return ! this.form.propSet.properties.find(el => el.id === property.id)
        // },
        dissolveByProperty(propertyPivot) {
            this.dissolveModal.propertyPivot = propertyPivot;
            this.dissolveModal.visibility = true;
        },
        closeDissolveModal() {
            this.dissolveModal.visibility = false;
            this.dissolveModal.propertyPivot = null;
            this.dissolveModal.loading = false;
        },
        confirmDissolve() {
            var self = this;
            this.dissolveModal.loading = true;
            this.shopProductStore
                .dissolveByProperty(this.form.id, this.dissolveModal.propertyPivot.property.id)
                .then(function () {
                    self.closeDissolveModal();
                    self.$notify({
                        title: self.$t('Product dissolved successfully.'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                    });
                    self.$router.push({ name: 'product-list' });
                })
                .catch(function (error) {
                    self.dissolveModal.loading = false;
                    self.$notify.error({
                        title: self.$t('An error occurred while dissolving the product.'),
                        message: _.get(error, 'message', ''),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    });
                });
        },
        deletePropertyPivot(propertyPivot) {
            const i = _.findIndex(this.form.propertyPivots, (el) => el.id === propertyPivot.id);
            if (i >= 0) this.markPropertyPivotAsDeleted(i);
        },
        restorePropertyPivot(propertyPivot) {
            const i = _.findIndex(this.form.propertyPivots, (el) => el.id === propertyPivot.id);
            if (i >= 0) this.unmarkPropertyPivotAsDeleted(i);
        },
        hover(event) {
            event.target.closest('tr').classList.add('hover');
        },
        blur(event) {
            event.target.closest('tr').classList.remove('hover');
        },
        setFormPropSet(propSet) {
            return this.shopProductStore.setFormPropSet(propSet);
        },
        setFormPropertyPivot(propertyPivot) {
            return this.shopProductStore.setFormPropertyPivot(propertyPivot);
        },
        setFormPropertyPivots(propertyPivots) {
            return this.shopProductStore.setFormPropertyPivots(propertyPivots);
        },
        markPropertyPivotAsDeleted(index) {
            return this.shopProductStore.markFormPropertyPivotAsDeleted(index);
        },
        unmarkPropertyPivotAsDeleted(index) {
            return this.shopProductStore.unmarkFormPropertyPivotAsDeleted(index);
        },
        propertyAutocomplete(payload) {
            return this.shopProductStore.propertyAutocomplete(payload);
        },
        fetchPropTypeOptions() {
            return this.shopProductStore.fetchPropTypeOptions();
        },
        fetchPropertyOptions(shopID) {
            return this.shopProductStore.fetchPropertyOptions(shopID);
        },
    },
    mounted() {
        if (!this.propSet && this.options.propSet.items.length) this.propSet = this.options.propSet.items[0];
    },
};
</script>

<style lang="sass" scoped>
.picked-options
    display: flex
    flex-wrap: wrap
    gap: 6px
    padding: 0 0 10px
    .picked-option
        display: inline-flex
        align-items: center
        gap: 7px
        padding: 4px 9px
        border: 1px solid #dcdfe6
        border-radius: 4px
        background: #f5f7fa
        font-size: 12px
        .dot
            width: 11px
            height: 11px
            border-radius: 3px
            border: 1px solid rgba(0, 0, 0, .12)
        i
            cursor: pointer
            color: #909399
            &:hover
                color: #f56c6c

.variant-consequence
    display: flex
    // centred, so the small help button does not push the text to the top edge
    align-items: center
    .help-button
        margin-left: auto
        width: 18px
        height: 18px
        min-height: 0
        padding: 0
        font-size: 10px
        line-height: 16px
    gap: 10px
    padding: 8px 10px
    margin-bottom: 10px
    border-radius: 4px
    background: #f5f7fa
    font-size: 13px
    color: #606266
    .new
        color: #67c23a
        font-weight: 600

::v-deep
    .el-dialog
        max-width: 900px
.panel
    min-height: auto
    margin-bottom: 15px
    border-radius: 4px
    border: 1px solid $--border-color-base
    transition: $--border-transition-base
    &.no-body
        .body
            display: none
        .header
            border-radius: 4px
    &.clickable
        cursor: pointer
        &:hover
            border: 1px solid $--shop-color-primary
    .header
        padding: 8px 15px
        padding-right: 34px
        background: lighten($color-body, 2%)
        display: flex
        justify-content: space-between
        border-top-right-radius: 4px
        border-top-left-radius: 4px
        .infos
            display: flex
            color: $color-grey-text
            .info + .info
                margin-left: 10px
            .active
                color: $--shop-color-primary
        label
            span + span
                margin-left: 10px
            span.info
                color: $color-grey-text
                &.active
                    color: $--shop-color-primary
                &.condition
                    font-size: 12px
            // the unique key beside the name, kept quiet so the name leads
            code.pivot-key
                margin-left: 7px
                font-family: monospace
                font-size: 10px
                font-weight: normal
                color: $color-grey-text
                opacity: .45
            .condition-tag
                margin-left: 10px
                i
                    margin-right: 4px
    .body
        min-height: 52px
        padding: 8px 15px
        ul
            padding: 0
            margin: 0
            margin-top: 4px
            li
                display: inline-block
                max-width: 100%
                margin-right: 4px
                margin-bottom: 4px
                // a long value (a description text) wraps inside the card
                // instead of overflowing it, capped at three lines; the
                // full text is in the modal the card opens
                .el-tag
                    max-width: 100%
                    height: auto
                    padding-top: 4px
                    padding-bottom: 4px
                    // 1px border + 4px padding + 18px line = the 28px medium tag
                    line-height: 18px
                    white-space: normal
                    // clamped on the inner span, not the tag: overflow clips at
                    // the padding edge, so a fourth line would show in the padding
                    .value
                        overflow-wrap: anywhere
                        display: -webkit-box
                        -webkit-box-orient: vertical
                        -webkit-line-clamp: 3
                        overflow: hidden
    li.handle, .handle label
        cursor: move

.property-modal-form
    min-height: 60px
    .alert
        margin-top: 0
    .property-button
        margin: 0
        margin-right: 4px
        margin-bottom: 4px
        position: relative
        display: inline-flex
        justify-content: center
        align-items: center
        text-align: left
        gap: 0.5rem
        // height: 27px
        &.el-button--info
            &.match
                background: $--shop-color-primary
                border-color: $--shop-color-primary
                color: white
            &.highlight
                background: $color-grey-text
                border-color: $color-grey-text
                color: white
        &::v-deep small
            opacity: .6
        .property-label
            display: flex
            flex-direction: column
            align-items: flex-start
            line-height: 1.25
            .name
                margin: 0
            // one muted sub-line: the unique key (monospace, like the field that sets it) and the type
            .meta
                display: inline-flex
                align-items: center
                gap: 5px
                opacity: .6
                font-size: 11px
                .key
                    font-family: monospace
        span.color
            width: 5px
            display: inline-block
            position: absolute
            border-radius: 20px
            left: 3px
            top: 3px
            bottom: 3px

.add-option
    max-width: 260px
    // top: 1px

.info-tooltip
    margin-left: 4px
    font-size: 1rem
    top: 2px
    position: relative
    opacity: 0.6

.property
    margin: 0
    padding: 0
    position: relative
    isolation: isolate
    .panel
        background: white
        transition: opacity 0.15s
    &.deleted
        .panel
            opacity: 0.6
    .delete-button,
    .restore-button,
    .dissolve-button
        position: absolute
        top: 11px
        right: 14px
        padding: 0
        // bare icons, not circles: undo the global .is-circle 30px minimum,
        // which centres the icon in a taller box below the header label
        min-width: 0
        min-height: 0
        background: none
        border: none
        z-index: 1
    .dissolve-button
        right: 44px

.el-button.property-button.is-plain:not(.el-button--primary)
    ::v-deep > .fas
        opacity: .3

span.unit
    margin-left: 4px
    opacity: .5

.dissolve-product-dialog
    .modal-body
        .alert
            display: flex
            align-items: center
            margin: 0
            i
                min-width: 2rem
                font-size: 1.4rem
                color: $--color-warning

.sticky
    position: sticky
    top: 1rem
    z-index: 1000

.el-input
    i.unit
        line-height: 0
        height: 100%
        margin-right: 10px
        display: flex
        align-items: center

.el-input-group__append button
    border-top-left-radius: 0
    border-bottom-left-radius: 0

.value-options
    max-height: calc(100vh - 10vh - 6vh - 240px)
    overflow-y: auto
    table td .el-button--text
        padding: 0

.options-loading-more
    display: flex
    align-items: center
    justify-content: center
    gap: 8px
    padding: 12px
    color: $color-grey-text

.property-value-form
    padding: 0

table
    margin-bottom: 1rem
    border-collapse: collapse
    isolation: isolate
    thead
        position: sticky
        top: 0
        background: white
        z-index: 2
        th
            white-space: nowrap
    tbody
        tr:nth-child(even)
            background: darken($--background-color-base, 1%)
        tr:nth-child(odd)
            background: lighten($--background-color-base, 1%)
    .check, .image, .color
        width: 1px
        white-space: nowrap
    .image
        padding-top: 2px !important
        padding-bottom: 2px !important
        img
            max-height: 31px
            width: auto
            border-radius: 4px
    .actions
        width: 1px
        white-space: nowrap

    .circle
        margin-right: 4px

    tr.clickable
        &.hover
            color: $--shop-color-primary
            td
                background: lighten($--shop-color-primary, 40%)
        .event-listener
            cursor: pointer

        &.active td
            background: lighten($--shop-color-primary, 38%)
            color: $--shop-color-primary

        // &.match td
        //     background: $--shop-color-primary
        //     border-color: $--shop-color-primary
        //     color: white
        // &.highlight td
        //     background: $color-grey-text
        //     border-color: $color-grey-text
        //     color: white

.table
    th.surcharge,
    td.surcharge
        white-space: nowrap
        text-align: right
        padding-right: 16px

// The surcharge sits next to the value, never under it: the tag lays its two
// spans out in a row and only the value may wrap.
.property .body li .el-tag
    display: inline-flex
    align-items: baseline
    gap: 6px
    .value
        min-width: 0
    .surcharge
        flex-shrink: 0
        white-space: nowrap
        opacity: .7
        font-size: 11px
        &.differs
            text-decoration: underline dotted
            text-underline-offset: 2px
            cursor: help

.table td.surcharge .differs
    text-decoration: underline dotted
    text-underline-offset: 2px
    cursor: help
</style>
